import { useState, useEffect } from 'react'

export default function APITest() {
  const [apiStatus, setApiStatus] = useState('Testing...')
  const [collections, setCollections] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    testAPIConnection()
  }, [])

  const testAPIConnection = async () => {
    try {
      // Test 1: Direct API call to backend
      console.log('Testing API connection to http://localhost:3001/api')

      const response = await fetch('http://localhost:3001/api/destinations', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })

      console.log('Response status:', response.status)

      if (response.ok) {
        const data = await response.json()
        console.log('API Response:', data)
        setApiStatus('✅ Connected to Payload CMS!')
        setCollections(data)
      } else {
        setApiStatus(`⚠️ API returned status: ${response.status}`)
        setError(`HTTP ${response.status}: ${response.statusText}`)
      }
    } catch (err) {
      console.error('API Test Error:', err)
      setApiStatus('❌ Connection Failed')
      setError(err.message)
    }
  }

  const testProxyConnection = async () => {
    try {
      console.log('Testing proxy connection to /api')

      // Test 2: Through Vite proxy
      const response = await fetch('/api/destinations')
      const data = await response.json()

      console.log('Proxy Response:', data)
      alert('Proxy test successful! Check console for details.')
    } catch (err) {
      console.error('Proxy Test Error:', err)
      alert('Proxy test failed: ' + err.message)
    }
  }

  return (
    <div className="min-h-screen bg-gray-100 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-center mb-8">
            Frontend ↔ Backend Connection Test
          </h1>

          {/* Status Card */}
          <div className="bg-white rounded-lg shadow-lg p-8 mb-6">
            <h2 className="text-2xl font-bold mb-4">Connection Status</h2>
            <div className="text-3xl font-bold mb-4">
              {apiStatus}
            </div>

            {error && (
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                <p className="font-bold">Error Details:</p>
                <p>{error}</p>
              </div>
            )}

            <div className="space-y-2 text-sm text-gray-600">
              <p><strong>Backend URL:</strong> http://localhost:3001</p>
              <p><strong>Testing Endpoint:</strong> /api/destinations</p>
              <p><strong>Proxy Configured:</strong> {'/api → http://localhost:3001/api'}</p>
            </div>
          </div>

          {/* API Response */}
          {collections && (
            <div className="bg-white rounded-lg shadow-lg p-8 mb-6">
              <h2 className="text-2xl font-bold mb-4">API Response</h2>
              <div className="bg-gray-100 p-4 rounded overflow-auto max-h-96">
                <pre className="text-xs">
                  {JSON.stringify(collections, null, 2)}
                </pre>
              </div>
              <div className="mt-4">
                <p className="text-green-600 font-semibold">
                  ✅ Found {collections.totalDocs} destination(s)
                </p>
              </div>
            </div>
          )}

          {/* Test Buttons */}
          <div className="bg-white rounded-lg shadow-lg p-8 mb-6">
            <h2 className="text-2xl font-bold mb-4">Manual Tests</h2>
            <div className="space-y-4">
              <button
                onClick={testAPIConnection}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg transition"
              >
                🔄 Re-test Direct API Connection
              </button>

              <button
                onClick={testProxyConnection}
                className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg transition"
              >
                🔌 Test Vite Proxy Connection
              </button>

              <a
                href="http://localhost:3001/api/destinations"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full bg-purple-600 hover:bg-purple-700 text-white font-bold py-3 px-6 rounded-lg transition text-center"
              >
                🌐 Open API in New Tab
              </a>
            </div>
          </div>

          {/* Instructions */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
            <h3 className="font-bold text-blue-900 mb-2">What This Page Tests:</h3>
            <ul className="list-disc list-inside space-y-1 text-blue-800">
              <li>Backend server is running on port 3001</li>
              <li>MongoDB Atlas connection is working</li>
              <li>Payload CMS API is accessible</li>
              <li>Frontend can fetch data from backend</li>
              <li>CORS is configured correctly</li>
            </ul>

            <h3 className="font-bold text-blue-900 mt-4 mb-2">Next Steps:</h3>
            <ul className="list-disc list-inside space-y-1 text-blue-800">
              <li>Create admin account at <a href="http://localhost:3001/admin" className="underline" target="_blank" rel="noopener noreferrer">localhost:3001/admin</a></li>
              <li>Add some test destinations in the CMS</li>
              <li>Refresh this page to see the data</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
